export const delay = (timeInMilliseconds: number) => {
    return new Promise(res => setTimeout(res, timeInMilliseconds));
};
